<template>
  <div>
    <div class="home-page__highlights">
      <div class="container">
        <div class="row">
          <div class="col-md-4"></div>
          <div class="col-md-8">
            <swiper
              ref="awesomeSwiperHighlights"
              :options="swiperOptionHighlights"
            >
              <swiper-slide v-bind:key="index" v-for="(item, index) in 5">
                <div class="generic-slider__details">
                  <div class="generic-slider__img">
                    <img src="https://picsum.photos/id/300/900/500" />
                  </div>
                </div>
              </swiper-slide>
            </swiper>
          </div>
        </div>
      </div>
    </div>

    <div class="home-page__services">
      <div class="container">
        <nav>
          <div class="nav nav-tabs" id="nav-tab" role="tablist">
            <a
              class="nav-item nav-link active"
              id="nav-home-tab"
              data-toggle="tab"
              href="#nav-home"
              role="tab"
              aria-controls="nav-home"
              aria-selected="true"
              >Services</a
            >
            <a
              class="nav-item nav-link"
              id="nav-profile-tab"
              data-toggle="tab"
              href="#nav-profile"
              role="tab"
              aria-controls="nav-profile"
              aria-selected="false"
              >Products</a
            >
          </div>
        </nav>
        <div class="tab-content" id="nav-tabContent">
          <div
            class="tab-pane fade show active"
            id="nav-home"
            role="tabpanel"
            aria-labelledby="nav-home-tab"
          >
            <h2 class="generic-title">Services</h2>
            <h3 class="generic-description">
              Our services meet a range of business challenges
            </h3>
            <div class="row">
              <div
                class="col-md-4"
                v-bind:key="index"
                v-for="(item, index) in 3"
              >
                <div class="services-card">
                  <i class="icon-document"></i>
                  <p class="services-card-content">
                    Request for a register for controlled or semi controlled
                    drugs custody
                  </p>
                  <a href="#" class="view-details">
                    View Details
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div
            class="tab-pane fade"
            id="nav-profile"
            role="tabpanel"
            aria-labelledby="nav-profile-tab"
          >
            <h2 class="generic-title">Products</h2>
            <h3 class="generic-description">
              Our services meet a range of business challenges
            </h3>
            <div class="row">
              <div
                class="col-md-4"
                v-bind:key="index"
                v-for="(item, index) in 3"
              >
                <div class="services-card">
                  <i class="icon-document"></i>
                  <p class="services-card-content">
                    Request for a register for controlled or semi controlled
                    drugs custody
                  </p>
                  <a href="#" class="view-details">
                    View Details
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="home-page__media-center">
      <div class="container">
        <h2 class="generic-title">Media center</h2>
        <h3 class="generic-description">
          Your gate to collect what you need to know
        </h3>
      </div>
      <div class="row">
        <div class="col-md-3" v-bind:key="index" v-for="(item, index) in 4">
          <div class="media-center-card">
            <img src="https://picsum.photos/id/340//575" />
            <div class="card-details">
              <h3>Video Gallery</h3>
            </div>
          </div>
        </div>
      </div>
      <div class="show-all">
        <a href="#">See All</a>
      </div>
    </div>

    <div class="home-page__send-iquiry">
      <div class="container">
        <h2 class="generic-title">Send Iquiry</h2>
        <h3 class="generic-description">
          have some questions, we are here for you !
        </h3>
        <div class="row">
          <div class="col-md-3">
            <i class="icon-send-mail"></i>
          </div>
          <div class="col-md-9">
            <form class="">
              <div class="row">
                <div class="col-md-6">
                  <div class="input-field">
                    <input type="text" placeholder="Name" />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="input-field">
                    <input type="number" placeholder="Phone" />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="input-field">
                    <input type="number" placeholder="Code of country" />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="input-field">
                    <input type="text" placeholder="Name of Company" />
                  </div>
                </div>
              </div>
              <button type="submit">Send</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
//import "swiper/swiper.min.css";

export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      swiperOptionHighlights: {
        pagination: {
          el: ".swiper-pagination",
          dynamicBullets: true,
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        loop: false,
        slidesPerView: 1,
        spaceBetween: 0,
        allowTouchMove: true,
        centeredSlides: false,
        breakpoints: {
          768: {
            slidesPerView: 1,
            spaceBetween: 0,
          },
          500: {
            slidesPerView: 1.08,
            spaceBetween: 10,
            centeredSlides: true,
          },
        },
      },
      swiperOptionLinks: {
        pagination: {
          el: ".swiper-pagination",
          dynamicBullets: true,
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        loop: true,
        slidesPerView: 6.5,
        spaceBetween: 30,
        allowTouchMove: true,
        centeredSlides: true,
        breakpoints: {
          768: {
            slidesPerView: 4,
            spaceBetween: 20,
          },
          500: {
            slidesPerView: 1.08,
            spaceBetween: 10,
            centeredSlides: true,
          },
        },
      },
    };
  },
  mounted() {
    this.$refs.awesomeSwiperLinks.destroySwiper();
    this.$refs.awesomeSwiperLinks.initSwiper();
  },
};
</script>
